import { Link, useLocation } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import catalog from "../data/catalog";
import { WHATSAPP_URL } from "./CTAButtons";
import WhatsAppIcon from "./WhatsAppIcon";

export default function StickyCTA() {
  const loc = useLocation();
  if (loc.pathname === "/request") return null;
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-3 bg-white border-t border-slate-200 shadow-[0_-4px_12px_rgba(10,37,64,0.08)]"
      data-testid="mobile-sticky-cta"
    >
      <a
        href={`tel:${catalog.PHONE_TEL}`}
        className="flex flex-col items-center justify-center gap-1 py-2.5 text-ink active:bg-slate-100"
        data-testid="sticky-call"
      >
        <Phone className="h-5 w-5 text-safety" />
        <span className="text-[11px] font-head font-bold uppercase tracking-wide">Call</span>
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-1 py-2.5 text-ink active:bg-slate-100 border-x border-slate-200"
        data-testid="sticky-whatsapp"
      >
        <WhatsAppIcon className="h-5 w-5 text-[#25D366]" />
        <span className="text-[11px] font-head font-bold uppercase tracking-wide">WhatsApp</span>
      </a>
      <Link
        to="/request"
        className="flex flex-col items-center justify-center gap-1 py-2.5 bg-safety text-white active:bg-safety-600"
        data-testid="sticky-quote"
      >
        <FileText className="h-5 w-5" />
        <span className="text-[11px] font-head font-bold uppercase tracking-wide">Quote</span>
      </Link>
    </div>
  );
}
